import { useAppSelector } from '../../../hooks/redux';
import { Theme, useMediaQuery } from '@material-ui/core';
import CreateButtonFab from '../../../ui-component/CreateButtonFab';
import AddIcon from '@mui/icons-material/Add';
import { SxProps } from '@material-ui/system';

const MobileCreateButton = ({ sx }: { sx?: SxProps }) => {
    const { buttonAction } = useAppSelector((state) => state.mobileCreateButton);
    const matchSm = useMediaQuery((themeParam: Theme) => themeParam.breakpoints.down('sm'));

    return buttonAction && matchSm ? (
        <CreateButtonFab color="secondary" onClick={buttonAction} sx={sx}>
            <AddIcon fontSize="small" />
        </CreateButtonFab>
    ) : null;
};

export default MobileCreateButton;
